import { render } from "./techStackResults.vue?vue&type=template&id=4fcda7a9"
import script from "./techStackResults.vue?vue&type=script&lang=js"
export * from "./techStackResults.vue?vue&type=script&lang=js"

import "./techStackResults.vue?vue&type=style&index=0&id=4fcda7a9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__